import React from 'react';
import clsx from 'clsx';
import { bool, func, object } from 'prop-types';

import Radio from '@material-ui/core/Radio';

import TagSelect from './TagSelect';

import defaultClasses from './RadioTagSelect.module.css';

const RadioTagSelect = ({
    disabled,
    error,
    onBlur,
    onChange,
    RadioProps: {
        value: radioValue,
        ...RadioProps
    },
    target,
    ...props
}) => {
    const isChecked = radioValue === target;
    return (
        <TagSelect
            control={
                <Radio
                    checked={isChecked}
                    classes={{
                        root: clsx(
                            defaultClasses.control,
                            {
                                [defaultClasses.controlError]: error
                            }
                        )
                    }}
                    color="primary"
                    disabled={disabled}
                    onBlur={onBlur}
                    {...RadioProps}
                    value={radioValue}
                />
            }
            disabled={disabled || !isChecked}
            error={error}
            onBlur={onBlur}
            onChange={onChange}
            {...props}
        />
    );
};

RadioTagSelect.defaultProps = {
    disabled:   false,
    error:      false,
    onBlur:     () => {},
    onChange:   () => {},
    RadioProps: {}
};

RadioTagSelect.propTypes = {
    disabled:   bool,
    error:      bool,
    onBlur:     func,
    onChange:   func,
    RadioProps: object
};

export default RadioTagSelect;
